var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailruWhitesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_11898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4062 8C10.406 8.6381 10.1524 9.24999 9.7012 9.70119C9.24999 10.1524 8.6381 10.406 8 10.4062C7.3619 10.406 6.75001 10.1524 6.2988 9.70119C5.8476 9.24999 5.59401 8.6381 5.59378 8C5.59401 7.3619 5.8476 6.75001 6.2988 6.2988C6.75001 5.8476 7.3619 5.59401 8 5.59378C8.6381 5.59401 9.24999 5.8476 9.7012 6.2988C10.1524 6.75001 10.406 7.3619 10.4062 8ZM8 0C3.58933 0 0 3.58933 0 8C0 12.4107 3.58933 16 8 16C9.60829 16.0024 11.1796 15.5174 12.5067 14.6089L12.5298 14.5929L11.4516 13.3396L11.4338 13.3511C10.41 14.0106 9.21779 14.3609 8 14.36C4.49333 14.36 1.64 11.5067 1.64 8C1.64 4.49333 4.49333 1.64 8 1.64C11.5067 1.64 14.36 4.49333 14.36 8C14.36 8.45422 14.3093 8.91467 14.2098 9.36711C14.0089 10.1929 13.4311 10.4453 12.9973 10.4116C12.5609 10.376 12.0498 10.0649 12.0462 9.30489V8C12.0462 5.76889 10.2311 3.95378 8 3.95378C5.76889 3.95378 3.95378 5.76889 3.95378 8C3.95378 10.2311 5.76889 12.0462 8 12.0462C8.53316 12.0476 9.06125 11.9427 9.55344 11.7378C10.0456 11.5328 10.4921 11.2318 10.8667 10.8524C11.0842 11.1931 11.3781 11.4784 11.7251 11.6856C12.0721 11.8929 12.4627 12.0163 12.8658 12.0462C13.524 12.0974 14.1782 11.9058 14.7049 11.5076C15.184 11.1431 15.5422 10.6169 15.7404 9.98489C15.7716 9.88267 15.8293 9.64889 15.8293 9.64711L15.8311 9.63822C15.9476 9.13156 16 8.62489 16 8C16 3.58933 12.4107 0 8 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_11898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailruWhitesvg);
export default __webpack_public_path__ + "static/media/mailru-white.svg.8f1a5fa6af7c9e77b6294c0f2c02601c.svg";
export { ForwardRef as ReactComponent };